import { addLoadingState, removeLoadingState } from "../../assets/js/utils/dom.js";
import { showHinweis } from "../merkzettel-hinweis/showHinweis.js";
import { artikelLoeschen, verarbeiteVollstaendigesEntfernen, verarbeiteEinzellistenEntfernen } from "../../assets/js/entfernen-aktionen.js";
import { sendeDlSignal } from "../../assets/js/datalayer.js";

export class ArtikelEntfernenOverlay extends HTMLElement {
  static tag = "artikel-entfernen-overlay";
  static {
    if (!customElements.get(ArtikelEntfernenOverlay.tag)) {
      customElements.define(ArtikelEntfernenOverlay.tag, ArtikelEntfernenOverlay);
    }
  }

  constructor() {
    super();
    this.events = ["submit"];
  }

  connectedCallback() {
    this.render();
    this.addListener();
  }

  disconnectedCallback() {
    this.removeListener();
  }

  render() {
    const template = document.getElementById("sbe-merkzettel-template-artikel-entfernen-overlay");
    if (!template) {
      return;
    }
    const clone = template.content.cloneNode(true);
    this.overlay = clone.querySelector("[id='sbe-merkzettel-artikel-entfernen-overlay']") ?? clone.querySelector("dialog");
    this.fullDeleteForm = this.overlay.querySelector("form[data-action='delete-from-merkzettel-and-all-lists']");
    this.singleListDeleteForm = this.overlay.querySelector("form[data-action='delete-from-single-list']");
    this.appendChild(clone);
  }

  /**
   * Konfiguriert das Overlay für einen konkreten Artikel und öffnet es.
   * Die Instanz wird wiederverwendet, daher wird die Sichtbarkeit bei jedem Öffnen zurückgesetzt.
   * ausloeser: Element, an dem das dl-signal für das zurückgehaltene remove_from_wishlist gesetzt wird.
   */
  open({ listType, fullDeleteAction, singleListDeleteAction, listEntry, artikelnummer, ausloeser }) {
    this.ausloeser = ausloeser;
    this.listEntry = listEntry;
    this.artikelnummer = artikelnummer;
    this.fullDeleteForm.action = fullDeleteAction;
    if (singleListDeleteAction) {
      this.singleListDeleteForm.action = singleListDeleteAction;
    }
    this.resetSichtbarkeit();
    this.zeigeFuerListType(listType);
    this.overlay.showModal();
  }

  resetSichtbarkeit() {
    const umschaltbareElemente = this.overlay.querySelectorAll("[data-for]");
    for (const element of umschaltbareElemente) {
      element.setAttribute("hidden", "");
    }
  }

  zeigeFuerListType(listType) {
    const elemente = this.overlay.querySelectorAll(`[data-for="${listType}"]`);
    for (const element of elemente) {
      element.removeAttribute("hidden");
    }
  }

  addListener() {
    for (const event of this.events) {
      this.addEventListener(event, this, { capture: true });
    }
  }

  removeListener() {
    for (const event of this.events) {
      this.removeEventListener(event, this, { capture: true });
    }
  }

  handleEvent(event) {
    const { type } = event;
    this[`handle${type}`](event);
  }

  async handlesubmit(event) {
    event.preventDefault();
    const { submitter, target } = event;
    const { action } = submitter.dataset;
    addLoadingState(submitter);
    try {
      await artikelLoeschen(target.action);
      sendeDlSignal(this.ausloeser, true);
      switch (action) {
        case "delete-from-merkzettel-and-all-lists":
          verarbeiteVollstaendigesEntfernen({
            target: this,
            artikelnummer: this.artikelnummer,
            listEntry: this.listEntry
          });
          break;
        case "delete-from-single-list":
          verarbeiteEinzellistenEntfernen({
            listEntry: this.listEntry
          });
          break;
        default:
          break;
      }
    } catch (error) {
      sendeDlSignal(this.ausloeser, false);
      showHinweis("warning-remove", this, "ArtikelEntfernen - handlesubmit");
      console.error(error);
    } finally {
      removeLoadingState(submitter);
      this.close();
    }
  }

  close() {
    this.overlay.close();
  }
}

/** Mountet genau eine Overlay-Instanz in den body (idempotent), sobald das über den head ausgelieferte Modul lädt. */
function mountArtikelEntfernenOverlay() {
  if (document.querySelector(ArtikelEntfernenOverlay.tag)) {
    return;
  }
  const overlay = document.createElement(ArtikelEntfernenOverlay.tag);
  document.body.appendChild(overlay);
}

mountArtikelEntfernenOverlay();
